module.exports = __webpack_public_path__ + "img/logo.e80411d4.svg";